import React from "react";
import { Platform, StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import CustomModal from "../../../common/general/CustomModal/CustomModal";

interface ConfirmModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "primary" | "destructive";
  onConfirm: () => void;
}

export function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary",
  onConfirm,
}: ConfirmModalProps) {
  return (
    <CustomModal
      visible={open}
      onRequestClose={() => onOpenChange(false)}
      style={{ maxWidth: 478 }}
      containerStyle={{ padding: 0 }}>
      <TouchableWithoutFeedback onPress={() => onOpenChange(false)}>
        <View style={styles.confirmOverlay}>
          <TouchableWithoutFeedback>
            <View style={styles.confirmSheet}>
              <Text style={styles.confirmTitle}>{title}</Text>
              <Text style={styles.confirmDesc}>{description}</Text>
              <View style={styles.confirmActions}>
                <CustomButton
                  text={cancelText}
                  size="m"
                  styleType="primaryLight"
                  onPress={() => onOpenChange(false)}
                  fullWidth
                />
                <View style={{ width: 12 }} />
                <CustomButton
                  text={confirmText}
                  size="m"
                  styleType={variant === "destructive" ? "danger" : "primary"}
                  onPress={onConfirm}
                  style={variant === "destructive" ? { backgroundColor: "#B91C1C", width: "50%" } : { width: "50%" }}
                  textStyle={{ color: "#FFFFFF", fontSize: 12, fontWeight: "500" }}
                />
              </View>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </CustomModal>
  );
}

const styles = StyleSheet.create({
  confirmOverlay: {
    justifyContent: "center",
    alignItems: "center",
  },
  confirmSheet: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 28,
    width: "100%",
    maxWidth: 400,
    gap: 16,
  },
  confirmTitle: {
    fontSize: 17,
    fontWeight: "700",
    color: "#111827",
    textAlign: "center",
  },
  confirmDesc: {
    fontSize: 13,
    color: "#6B7280",
    textAlign: "center",
    lineHeight: 20,
  },
  confirmActions: {
    flexDirection: "row",
    alignItems: "center",
  },
});
